/* eslint-disable no-self-assign */
import user from '@/api/user'
import get from 'lodash/get'

const INITIAL_STATE = {
  userList: {},
}

export default {
  namespace: 'user',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setUserList(state, { payload }) {
      return { ...state, userList: payload }
    },
  },

  effects: {
    *getUsers({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(user.getUsers, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'user/setUserList', payload: resData })
        successCallback?.()
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *createUser({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(user.createUser, {
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *editUser({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(user.editUser, {
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *editUserGroup({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const { userId, data } = payload

      const response = yield call(user.editUserGroup, {
        data,
        userId,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *deleteUser({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(user.deleteUser, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },
  },
}
